import RequestTableTooltip_vue_vue_type_script_setup_true_lang_default from "./RequestTableTooltip.vue.script.js";
//#region src/v2/blocks/request-block/components/RequestTableTooltip.vue
var RequestTableTooltip_default = RequestTableTooltip_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestTableTooltip_default as default };

//# sourceMappingURL=RequestTableTooltip.vue.js.map